import React from 'react'
import { graphql } from 'gatsby'
import CollageStatsCallout, {
  CollageStatsCalloutContent,
} from 'src/components/organisms/ctas/collageStatsCallout'

// NOTE: Replace this local type with `PrismicPageDataBodyCollageStatsCallout`
// from 'src/typings/generated/graphql' after the slice is added to the Prismic
// Custom Type and `npm run type-graphql` is run.
type PrismicPageDataBodyCollageStatsCallout = {
  primary: {
    anchor?: string | null
    image_1?: any
    image_2?: any
    image_3?: any
    image_4?: any
    headline?: string | null
    description?: any
    primary_button_text?: string | null
    primary_button_variant?: string | null
    primary_button_link?: any
    secondary_button_text?: string | null
    secondary_button_link?: any
    modal_title?: string | null
    modal_option_1_label?: string | null
    modal_option_1_link?: any
    modal_option_2_label?: string | null
    modal_option_2_link?: any
    modal_continue_text?: string | null
  }
  items?: Array<{
    stat_value?: string | null
    stat_label?: string | null
  }> | null
}

type Props = {
  slice: PrismicPageDataBodyCollageStatsCallout
}

const CollageStatsCalloutSlice = ({ slice }: Props) => {
  const content: CollageStatsCalloutContent = {
    anchor: slice.primary.anchor ?? undefined,
    image1: {
      image: slice.primary.image_1?.gatsbyImageData ?? undefined,
      alt: slice.primary.image_1?.alt ?? undefined,
    },
    image2: {
      image: slice.primary.image_2?.gatsbyImageData ?? undefined,
      alt: slice.primary.image_2?.alt ?? undefined,
    },
    image3: {
      image: slice.primary.image_3?.gatsbyImageData ?? undefined,
      alt: slice.primary.image_3?.alt ?? undefined,
    },
    image4: {
      image: slice.primary.image_4?.gatsbyImageData ?? undefined,
      alt: slice.primary.image_4?.alt ?? undefined,
    },
    headline: slice.primary.headline ?? undefined,
    description: slice.primary.description ?? undefined,
    stats: (slice.items ?? []).map(item => ({
      value: item?.stat_value ?? undefined,
      label: item?.stat_label ?? undefined,
    })),
    primaryButtonText: slice.primary.primary_button_text ?? undefined,
    primaryButtonVariant: slice.primary.primary_button_variant ?? undefined,
    primaryButtonLink: slice.primary.primary_button_link ?? undefined,
    secondaryButtonText: slice.primary.secondary_button_text ?? undefined,
    secondaryButtonLink: slice.primary.secondary_button_link ?? undefined,
    modal: {
      title: slice.primary.modal_title ?? '',
      option1Label: slice.primary.modal_option_1_label ?? '',
      option1Link: slice.primary.modal_option_1_link ?? undefined,
      option2Label: slice.primary.modal_option_2_label ?? '',
      option2Link: slice.primary.modal_option_2_link ?? undefined,
      continueText: slice.primary.modal_continue_text ?? 'Continue',
    },
  }

  return <CollageStatsCallout content={content} />
}

export default CollageStatsCalloutSlice

export const collageStatsCalloutFragment = graphql`
  fragment PageDataBodyCollageStatsCallout on PrismicPageDataBodyCollageStatsCallout {
    primary {
      anchor
      image_1 {
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 600)
      }
      image_2 {
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 600)
      }
      image_3 {
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 600)
      }
      image_4 {
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 600)
      }
      headline
      description {
        richText
      }
      primary_button_text
      primary_button_variant
      primary_button_link {
        ...BasicLinkFragment
      }
      secondary_button_text
      secondary_button_link {
        ...BasicLinkFragment
      }
      modal_title
      modal_option_1_label
      modal_option_1_link {
        ...BasicLinkFragment
      }
      modal_option_2_label
      modal_option_2_link {
        ...BasicLinkFragment
      }
      modal_continue_text
    }
    items {
      stat_value
      stat_label
    }
  }
`
